// https://material-ui.com/system/palette/

module.exports = Object.freeze({
  // This overrides CSSBaseline for the body tag
  background: { default: '#ffffff' },
  primary: { main: '#f0f6fa' },
  secondary: { main: '#cde3c3' },
  info: { 
    main: '#d3dfe6',
    dark: '#262431'
  },
  text: {
    primary: '#000000',
    secondary: '#1478a6'
  },
  toolbarBackground: {
    dark: '#062135',
    main: '#000051',
  },
  common: {
    black: '#000000',
    white: '#ffffff'
  },
  header: {
    primary: '#062135',
    secondary: '#000051'
  },
  chart: {
    primary: '#222222',
    secondary: '#43646F',
  },
  explore: {
    100: '#c4d99b',
    200: '#c2b27b',
    300: '#b78d68',
    400: '#a16c5e',
    500: '#825056',
    600: '#5e384b',
    700: '#37253c'
  },
  links: {
    default: '#1478a6',
    hover: '#126991',
  },
  // Land category charts
  blue: {
    100: '#bccacf',
    200: '#8fa7af',
    300: '#62848f',
    400: '#43646f',
    500: '#30474f',
    600: '#131c20'
  },
  // Location charts
  green: {
    100: '#c2d0bd',
    200: '#94ad8d',
    300: '#678a5c',
    400: '#49683f',
    500: '#30462a',
    600: '#182315'
  },
  // Revenue type charts (only first four)
  orange: {
    100: '#fcba8b',
    200: '#fa842e',
    300: '#e36000',
    400: '#b64d00',
    500: '#833a00',
    600: '#5b2700'
  },
  // Commodity charts
  purple: {
    100: '#dcd2df',
    200: '#b9a6bf',
    300: '#96799f',
    400: '#82568f',
    500: '#56395f',
    600: '#2b1c30'
  },
  // Not currently being used, but available if needed
  brown: {
    100: '#dfd6d2',
    200: '#bfaca6',
    300: '#9f8379',
    400: '#895d52',
    500: '#5f4339',
    600: '#30211c'
  },
  grey: {
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#494949'
  },
  tonalOffset: 0.5,
})
